
  <template>
    <div class="container">

      <div class="one">
        <span>公司矿井单位</span>
        </div>
      <div class="two">
        <vue-seamless-scroll :data="list" :class-option="optionLeft" class="container-11" >
          <ul class="item">
            <li
              v-for="(item,index) in list"
              :key="index"
              @click="towin(item.id)"
            >
              <img :src="item.thumbnail" alt="">
              <span>{{item.title}}</span>
            </li>
          </ul>
        </vue-seamless-scroll>
      </div>


    </div>

  </template>


<script>

export default {
  name: "Carousel",
  data () {
    return {
      list:[],
      flag:true,
      num:0
    }
  },
  props:{
    getList:{
      type:Array
    }
  },
watch:{
  getList:function(){
    if(this.getList[0].content.length==0){
      for(let i=0;i<5;i++){
        this.list.push({
          id:0,
          thumbnail:'',
          title:'#'
        })
      }
    }else {
      this.list=this.getList[0].content
    }
  }
},
  computed: {
    optionLeft () {
      return {
        direction: 2,
        limitMoveNum: this.list.length,
        hoverStop: true,
        step: 0.5
      }
    }
  },
 methods:{
   towin(id){
     if(id!=0){
       this.$router.push(`/content/${id}`)
     }

   }
 },
}
</script>

<style scoped>

/*.el-carousel__item{*/
/*  width: 400px;*/
/*}*/

.container {
  background-color: white;
  /*box-sizing: border-box;*/
  display: flex;

  /*clear: both;*/
  /*border: 1px solid #d0d0d0;*/
  /*box-shadow: 1px 1px 4px #ccc;*/
}
.one{
  display: block;
  width: 30px;
  text-align: center;
}
.two{
  overflow: hidden;
  height: 190px;
  width: 100%;
  padding: 0 20px 0 20px;
}
.one span{
  position: relative;
  top:28px;
  color: #2574c2;
  font-weight: bold;
  margin-bottom: 10px;
}
img{
 display: flex;
  margin: 0;
  padding: 0;
  width: 280px;
  height: 150px;
}
.item{
  /*width: 2000px;*/
  /*height: 300px;*/
  display: flex;
  flex-wrap: nowrap;
}
li{
  float: left;
  padding: 0 10px;
  list-style-type: none;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/Carousel.vue